import React from 'react';
import { Helmet } from 'react-helmet';
import ServicePage from '../components/ServicePage';
import html from '../content/endToEndAiConsulting.html.js';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function EndToEndAIConsulting() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'End-to-End AI Consulting Service',
    description:
      'Transforming your toughest challenges into scalable AI solutions, from strategy through production.',
    url: canonicalUrl,
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>End-to-End AI Consulting</title>
        <meta name="description" content="Comprehensive AI consulting from strategy to production deployment." />
        <meta property="og:title" content="End-to-End AI Consulting" />
        <meta property="og:description" content="Transform challenges into scalable AI solutions with our expert team." />
        <meta property="og:image" content="/assets/visuals/re-vr-headset-visionary.webp" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <ServicePage
        title="End-to-End AI Consulting"
        tagline="Transforming your toughest challenges into scalable AI solutions, from strategy through production."
        ctaText="Contact Us"
        ctaLink="/contact"
        htmlContent={html}
        imageSrc="/assets/visuals/re-vr-headset-visionary.webp"
        imageAlt="End-to-end AI consulting visual"
      />
    </>
  );
}
